'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useQueryState } from 'nuqs';
import { createContext, useContext, useEffect, useState } from 'react';
import { getCookie, setCookie } from '@/api/utils';
import { currencies, currenciesCodesList, mainCurrencies, } from '@/contexts/currency/currencies';
import useUserLocation from '@/hooks/useUserLocation';
const CurrencyContext = createContext(undefined);
export function CurrencyProvider({ children, defaultCurrency = 'USD' }) {
    const { userCurrencyByIp } = useUserLocation();
    const [searchCurrency] = useQueryState('currency_code');
    const [selectedCurrency, setSelectedCurrency] = useState(() => {
        const cookieCurrency = getCookie('currency_code');
        return searchCurrency || cookieCurrency || userCurrencyByIp || defaultCurrency;
    });
    useEffect(() => {
        const cookieCurrency = getCookie('currency_code');
        if (searchCurrency) {
            setSelectedCurrency(searchCurrency);
            setCookie('currency_code', searchCurrency);
        }
        else if (cookieCurrency) {
            setSelectedCurrency(cookieCurrency);
        }
        else {
            setSelectedCurrency(defaultCurrency);
            setCookie('currency_code', defaultCurrency);
        }
    }, [defaultCurrency, searchCurrency]);
    const changeCurrency = (currency) => {
        setSelectedCurrency(currency);
        setCookie('currency_code', currency);
    };
    return (_jsx(CurrencyContext.Provider, { value: {
            selectedCurrency,
            changeCurrency,
            currenciesCodesList,
            currencies,
            mainCurrencies,
        }, children: children }));
}
export function useCurrency() {
    const context = useContext(CurrencyContext);
    if (context === undefined) {
        throw new Error('useCurrency must be used within a CurrencyProvider');
    }
    return context;
}
